// extracted by mini-css-extract-plugin
export default {"largo":"PostSignUp_largo__sAtty"};